function imageSlider() {

  const imageSlider = new Swiper('.js-image-slider', {
    observer: true, 
    observeParents: true,
    loop: true,
    draggable: true,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    allowTouchMove: true,
    effect: 'slide',
    spaceBetween: 40,
    slidesPerView: 1,
    breakpoints: {
      760: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 40
      },
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.js-image-slider-next',
      prevEl: '.js-image-slider-prev',
    },
  });
  
  $('.js-image-slider').find('.swiper-slide-prev').css( 'visibility', 'hidden' );
  
  imageSlider.on('slideChange', function(){
    console.log('slide changed');
    $('.js-image-slider').find('.swiper-slide').css( 'visibility', '' );
  });
}


export default imageSlider;
